import type { GetBrandsByUserIdResponse } from "@nlc/shared-types";

import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { profileKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useGetBrandsByUserId(
  userId: number | string,
): UseQueryResult<GetBrandsByUserIdResponse> {
  return useQuery<GetBrandsByUserIdResponse>({
    queryFn: async () =>
      apiClient
        .url(`/users/${userId}/brands`)
        .get()
        .json<GetBrandsByUserIdResponse>(),
    queryKey: profileKeys.brandsByUserId(userId),
    refetchOnWindowFocus: false,
  });
}
